import type { MotionTrack } from '~/lib/motion'
import { m } from '~/paraglide/messages'
import { FirstPurchaseBonusTagIcon } from './icons/first-purchase-bonus-tag'
import { ShimmerBand } from './shimmer-band'

// The notice shimmer's loop, from the design's motion data: 12 seconds, of
// which only 0.3–1 s moves.
const SHIMMER_CYCLE_MS = 12_000

const at = (ms: number) => ms / SHIMMER_CYCLE_MS
const SWEEP_EASING = 'cubic-bezier(0.42, 0, 0.58, 1)'
const TILT_EASING = 'cubic-bezier(0.5, 0, 0.5, 1)'

// The band holds off-card for 0.3 s, then sweeps 720px right — past the
// widest card — fading in on the way out of the left edge and out again
// before it leaves; it tilts from -18° towards -34° and widens 5% as it
// goes. The rest of the cycle it waits, invisible.
const SHIMMER_TRACKS: MotionTrack[] = [
  {
    property: 'translate',
    values: ['0px 0px', '0px 0px', '720px 0px', '720px 0px'],
    times: [0, at(300), at(1_000), 1],
    easing: ['linear', SWEEP_EASING, 'linear'],
  },
  {
    property: 'opacity',
    values: [0, 0, 1, 1, 0, 0],
    times: [0, at(300), at(395.2), at(872.6), at(1_000), 1],
    easing: ['linear', 'ease-out', 'linear', 'ease-out', 'linear'],
  },
  {
    property: 'rotate',
    values: ['-18deg', '-32.32deg', '-33.69deg', '-33.69deg'],
    times: [0, at(275.2), at(502.5), 1],
    easing: [TILT_EASING, TILT_EASING, 'linear'],
  },
  {
    property: 'scale',
    values: ['1 1', '1.05 1', '1.05 1'],
    times: [0, at(502.5), 1],
    easing: 'linear',
  },
]

// The First-purchase bonus notice (GLOSSARY.md "First-purchase bonus
// (首購翻倍)"): the card leading the Time Crystals section while any visible
// pack has an active bonus — the ×2 art beside the bonus copy, swept by a
// shimmer from the moment it shows.
export function FirstPurchaseBonusNotice() {
  return (
    <div
      data-testid="first-purchase-bonus-notice"
      class="relative flex items-center gap-2 overflow-hidden rounded-[20px] bg-[#1FA8801A] px-3 py-3.5"
    >
      <FirstPurchaseBonusTagIcon
        class="size-10 shrink-0"
        testId="first-purchase-bonus-notice-tag"
      />
      <p class="min-w-0 flex-1 text-sm font-semibold leading-5 text-ink">
        {m.time_crystal_description()}
      </p>
      <ShimmerBand
        cycleMs={SHIMMER_CYCLE_MS}
        testId="first-purchase-bonus-shimmer"
        tracks={SHIMMER_TRACKS}
      />
    </div>
  )
}
